import React from "react";
import './Tools.css'
import javascript from './assets/javascript.png'
import html from './assets/html.png'
import css from './assets/css.png'
import angular from './assets/angular.png'
import react from './assets/react.png'
import cypress from './assets/cypress.png'
import git from './assets/git.png'
import typescript from './assets/typescript.png'
import node from './assets/node.png'

const Tools = () => {
  return (
    <section className='tools'>
      <h1 className='tools-title'>TOOLS</h1>
      <div className='tools-container'>
        <img src={javascript} alt='javascript icon' className='icon'/>
        <img src={html} alt='html icon' className='icon' />
        <img src={css} alt='css icon' className='icon' />
        <img src={angular} alt='angular icon' className='icon'/>
        <img src={react} alt='react icon' className='icon' />
        <img src={typescript} alt='typescript icon' className='icon' />
        <img src={cypress} alt='cypress icon' className='icon' />
        <img src={git} alt='git icon' className='icon' />
        <img src={node} alt='node icon' className='icon' />
      </div>
    </section>
  )
}

export default Tools